module.exports = __webpack_public_path__ + "static/media/feijoa_compote.daacbec9.png";